module.exports = __webpack_public_path__ + "img/whatsApp.28164695.png";